module.exports = __webpack_public_path__ + "static/media/virtual-events-2.43d32771.jpg";